<template>
  <b-modal @shown="toggleChat" body-class="bg-white" id="modal-chat" scrollable no-close-on-esc no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div style="position: relative">
        <h5>Diskusi</h5>
        <div>{{ dataLaporan?.nama_pemegang }}</div>
        <small class="fw-semibold">{{ dataLaporan?.nomor_kkprl }} | {{ dataLaporan?.jenis_kegiatan }}</small>
        <button
          type="button"
          class="close"
          aria-label="Close"
          style="position: absolute; top: 0; right: 0"
          @click="close()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </template>
    <template #default>
      <div :class="['chat-container d-block']">
        <div class="chat-body">
          <div v-if="isLodingChat" class="text-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-if="!isLodingChat && !dataChat.length" class="text-center">
            <small>Tidak ada diskusi</small>
          </div>
          <template v-if="!isLodingChat">
            <div v-for="d in dataChat" :class="[d.id_pengirim == user.id ? 'from-user' : 'from-admin']">
              <div class="message-wrapper">
                <div class="message">
                  {{ d.isi_chat }}
                </div>
              </div>
              <div class="chat-time">{{ formatDate(d.createdAt, 'DD/MM/YYYY HH.mm') }}</div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div>
        <div v-if="dataLaporan?.status_laporan !== 'Selesai'" class="chat-input">
          <input type="text" v-model="chatText" placeholder="Ketik pesan atau pertanyaan Anda..." />
          <button @click="sendChat" :disabled="!chatText || isLodingSend">
            <Loader v-if="isLodingSend" />
            <PaperPlane v-else />
          </button>
        </div>
        <div v-else class="text-center my-4">
          <small>Diskusi ditutup, laporan tahunan sudah selesai</small>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import supportAgent from '@/assets/support-agent.png'
import PaperPlane from '../Icons/PaperPlane.vue'
import Loader from '../Loader/Loader'
import axios from 'axios'
import { formatDate } from '../../helper/helpernew'
import Swal from 'sweetalert2'

export default {
  components: { PaperPlane, Loader },
  props: ['dataLaporan'],
  data() {
    return {
      supportAgent,
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || {}),
      isLodingSend: false,
      isLodingChat: false,
      chatText: '',
      roomChatId: null,
      dataChat: [],
    }
  },
  methods: {
    formatDate,
    async loadChat() {
      this.isLodingChat = true
      this.dataChat = []
      const id_chat_room = await this.checkRoomChat()
      if (id_chat_room) {
        const res = await axios.get(
          `${this.baseapiPengendalian}api/chat?sort=createdAt,ASC&limit=100&filter=id_chat_room,=,${id_chat_room}`,
          this.getApiOption(),
        )
        const resData = res.data.data
        if (resData.length) {
          this.dataChat = resData
          this.isLodingChat = false
          setTimeout(() => {
            this.$nextTick(() => {
              const box = document.getElementById('modal-chat___BV_modal_body_')
              if (box) {
                box.scrollTop = box.scrollHeight
              }
            })
          }, 100)
          return resData
        }
      }
      this.isLodingChat = false
      return []
    },
    async sendChat() {
      const id_chat_room = await this.checkRoomChat()
      if (!id_chat_room) {
        const resRoom = await axios.post(
          `${this.baseapiPengendalian}api/chat_room`,
          { id_laporan: this.dataLaporan.id },
          this.getApiOption(),
        )
        this.roomChatId = resRoom.data?.data.id || null
      }

      try {
        this.isLodingSend = true
        const formChat = {
          id_chat_room: this.roomChatId,
          id_penerima: this.user.role === 'Pemrakarsa' ? this.dataLaporan.id_penilai : this.dataLaporan.id_user,
          isi_chat: this.chatText,
        }
        await axios.post(`${this.baseapiPengendalian}api/chat`, formChat, this.getApiOption())
        this.chatText = ''
        this.loadChat()
      } catch (error) {
        Swal.fire({
          title: 'Gagal',
          text: 'Terjadi kesalahan saat mengirim pesan',
          icon: 'error',
        })
      } finally {
        this.isLodingSend = false
      }
    },
    async checkRoomChat() {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/chat_room?filter=id_laporan,=,${this.dataLaporan.id}`,
        this.getApiOption(),
      )
      const resData = res.data?.data[0]
      if (!resData) {
        this.roomChatId = null
        return null
      } else {
        this.roomChatId = resData.id
        return resData.id
      }
    },
    async toggleChat() {
      const dataChat = await this.loadChat()
      if (!dataChat.length) return
      const lastChat = dataChat[dataChat.length - 1]
      if (lastChat.id_penerima === `${this.user.id}`) {
        axios.put(`${this.baseapiPengendalian}api/chat/${lastChat.id}`, { read: true }, this.getApiOption())
      }
    },
    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
  async mounted() {
    // if (this.user.role === 'Pemrakarsa') {
    //   await this.checkRoomChat()
    //   await this.loadChat()
    // }
  },
}
</script>

<style scoped>
/* Wrapper dan tombol chat */
.chat-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

/* Tombol chat mengambang */
.btn-chat {
  background: #373737;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}
.btn-chat:hover {
  transform: scale(1.1);
}

.chat-header {
  padding: 12px;
  padding-top: 0px;
  border-bottom: 1px solid #ddd;
}

/* Kotak obrolan */
.chat-container {
  /* position: absolute;
  bottom: 80px;
  right: 0;
  width: 350px; */
  background: #fff;
  /* border-radius: 5px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15); */
  overflow: hidden;
  font-family: 'Inter', sans-serif;
}

/* Judul chat */
.chat-title {
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}

/* Area isi chat */
.chat-body {
  /* padding: 12px; */
  /* height: 500px; */
  overflow-y: auto;
  scrollbar-width: thin;
  font-size: 14px;
  /* position: relative; */
}
.day-divider {
  /* position: sticky;
  top: 0px;
  z-index: 100; */
  text-align: center;
  margin-bottom: 10px;
}
.day-divider span {
  background: #f1f1f1;
  font-size: 12px;
  padding: 2px 7px;
  border-radius: 9999px;
}

.from-user {
  text-align: right;
  margin-left: 50px;
  margin-bottom: 10px;
}
.from-user .message-wrapper {
  display: flex;
  justify-content: flex-end;
}
.from-user .message {
  background: #5a7dcc;
  color: #ffffff;
}
.from-user .chat-time {
  text-align: end;
  font-size: 12px;
  color: #373737;
}

.from-admin {
  text-align: left;
  margin-right: 50px;
  margin-bottom: 10px;
}
.from-admin .message-wrapper {
  display: flex;
  justify-content: flex-start;
}
.from-admin .message {
  background: #f1f1f1;
  color: #000000;
}
.from-admin .chat-time {
  text-align: start;
  font-size: 12px;
  color: #373737;
}

.message {
  border-radius: 5px;
  padding: 5px 10px;
}

/* Input area */
.chat-input {
  display: flex;
  border: 1px solid #ddd;
}
.chat-input input {
  flex: 1;
  border: none;
  padding: 10px;
  outline: none;
}
.chat-input button {
  background: #0078ff;
  border: none;
  color: white;
  padding: 10px 16px;
  cursor: pointer;
}
.chat-input button:hover:not([disabled]) {
  background: #005fcc;
}
.chat-input button[disabled] {
  opacity: 50%;
  cursor: default;
}

:deep(.data-loader i) {
  margin: 0px !important;
}

:deep(.modal-header) {
  display: block;
}

/* :deep(#modal-chat .modal-body) {
  padding: 0px;
} */

:deep(#modal-chat .modal-footer) {
  display: block;
}
</style>
